import { getQuery } from './util';

export default Object.keys(getQuery()).includes('embed');
